/**
 * Shared 15-minute session countdown for CTR pre-lander and sale banner.
 * Persists end timestamp in sessionStorage across page refreshes.
 * Loops automatically — when time expires, a new countdown starts immediately.
 */
(function () {
  const SHARED_TIMER_KEY = 'ctr-session-countdown-end';
  const PRELANDER_TIMER_PREFIX = 'ctr-gift-reveal-timer-';

  function parseEndTime(value) {
    const end = parseInt(value, 10);
    return Number.isNaN(end) ? null : end;
  }

  function isActiveEnd(end, now) {
    return end !== null && end > now;
  }

  function findPrelanderEndTime(now) {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (!key || !key.startsWith(PRELANDER_TIMER_PREFIX)) continue;

      const end = parseEndTime(sessionStorage.getItem(key));
      if (isActiveEnd(end, now)) return end;
    }

    return null;
  }

  function persistEndTime(end, sectionTimerKey) {
    sessionStorage.setItem(SHARED_TIMER_KEY, String(end));
    if (sectionTimerKey) {
      sessionStorage.setItem(sectionTimerKey, String(end));
    }
  }

  function getEndTime(countdownMinutes, sectionTimerKey) {
    const minutes = parseInt(countdownMinutes, 10) || 15;
    const now = Date.now();

    const sharedEnd = parseEndTime(sessionStorage.getItem(SHARED_TIMER_KEY));
    if (isActiveEnd(sharedEnd, now)) {
      if (sectionTimerKey) {
        sessionStorage.setItem(sectionTimerKey, String(sharedEnd));
      }
      return sharedEnd;
    }

    if (sectionTimerKey) {
      const sectionEnd = parseEndTime(sessionStorage.getItem(sectionTimerKey));
      if (isActiveEnd(sectionEnd, now)) {
        sessionStorage.setItem(SHARED_TIMER_KEY, String(sectionEnd));
        return sectionEnd;
      }
    }

    const prelanderEnd = findPrelanderEndTime(now);
    if (isActiveEnd(prelanderEnd, now)) {
      persistEndTime(prelanderEnd, sectionTimerKey);
      return prelanderEnd;
    }

    const end = now + minutes * 60 * 1000;
    persistEndTime(end, sectionTimerKey);
    return end;
  }

  window.CtrSessionCountdown = {
    SHARED_TIMER_KEY,
    getEndTime,
  };
})();
